import React, { useEffect, useState } from 'react';
import { Layout } from 'tea-component';
import Tabs from '@intelligence/components/NewIconTabs';
import OpinionsMetrics from './component/OpinionsMetrics';
import IntelligenceMetrics from './component/IntelligenceMetrics';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';

import './index.scss';
import { history, useIntl, useRouteMatch } from 'umi';
import MarqueeBanner from '@intelligence/components/MarqueeBanner/index';
const { Body, Sider, Content } = Layout;

export default () => {
  const [bodyLoading, setBodyLoading] = useState(false);

  const { formatMessage } = useIntl();

  const { params }: any = useRouteMatch() || {};
  const tabId = params?.tab || 'IntelligenceMetrics';

  useEffect(() => {
    if (!['IntelligenceMetrics', 'OpinionsMetrics', 'MobileGameFields', 'PCConsoleFields', 'CompanyFields', 'DeviceMetrics']?.includes(tabId)) {
      history.push(`/intelligence/sourcesMetrics/metrics/IntelligenceMetrics`);
    }
  }, [tabId]);

  const tabs = [
    {
      id: 'IntelligenceMetrics',
      label: formatMessage({ id: 'dbi-sm-intelligence-metrics' }),
      component: <IntelligenceMetrics />,
    },
    {
      id: 'OpinionsMetrics',
      label: formatMessage({ id: 'dbi-sm-opinions-sources' }),
      component: <OpinionsMetrics />,
    },
    {
      id: 'MobileGameFields',
      label: (
        <div className="dbi-tab-flex">
          {formatMessage({ id: 'dbi-sm-mobile-game-fields' })}
          <TipContext
            placement="bottom"
            className="dbi-tab-icon"
            style={{ width: 450 }}
            placementOffset={20}
            tipText={
              <div>
                <p>{formatMessage({id: 'dbi_sm_mobile_game_field_info1'})}</p>
                <p>{formatMessage({id: 'dbi_sm_mobile_game_field_info2'})}</p>
                <p>{formatMessage({id: 'dbi_sm_mobile_game_field_info3'})}</p>
              </div>
            }
          />
        </div>
      ),
      component: <OpinionsMetrics />,
    },
    {
      id: 'PCConsoleFields',
      label: (
        <div className="dbi-tab-flex">
          {formatMessage({ id: 'dbi-sm-PC&Console' })}
          <TipContext
            placement="bottom"
            className="dbi-tab-icon"
            style={{ width: 450 }}
            placementOffset={20}
            tipText={
              <div>
                <p>{formatMessage({id: 'dbi_sm_pc_game_field_info1'})}</p>
                <p>{formatMessage({id: 'dbi_sm_pc_game_field_info2'})}</p>
                <p>{formatMessage({id: 'dbi_sm_pc_game_field_info3'})}</p>
                <p>{formatMessage({id: 'dbi_sm_pc_game_field_info4'})}</p>
              </div>
            }
          />
        </div>
      ),
      component: <OpinionsMetrics />,
    },
    {
      id: 'CompanyFields',
      label: (
        <div className="dbi-tab-flex">
          {formatMessage({ id: 'dbi-sm-company-fields' })}
          <TipContext
            placement="bottom"
            className="dbi-tab-icon"
            style={{ width: 450 }}
            placementOffset={20}
            tipText={
              <div>
                <p>{formatMessage({id: 'dbi_sm_company_field_info1'})}</p>
                <p>{formatMessage({id: 'dbi_sm_company_field_info2'})}</p>
                <p>{formatMessage({id: 'dbi_sm_company_field_info3'})}</p>
              </div>
            }
          />
        </div>
      ),
      component: <OpinionsMetrics />,
    },
    {
      id: 'DeviceMetrics',
      label: formatMessage({ id: 'dbi-sm-device-metrics' }),
      component: <OpinionsMetrics />,
    },
  ];
  return (
    <Content>
      <Content.Header
        title={formatMessage({ id: 'dbi-sm-metrics' })}
        className="contentHead-normal"
      >
        <div className="header-tab">
          <Tabs
            ceiling
            newMarkIdsMappingKey="Sources&MetricsMetrics"
            tabs={tabs}
            animated={false}
            activeId={tabId}
            onActive={(tab) => {
              const url = `/intelligence/sourcesMetrics/metrics/${tab.id}`;
              history.push(url);
            }}
          />
        </div>
      </Content.Header>
      <Content.Body full>
        <MarqueeBanner />
        {bodyLoading ? null : (
          tabs.map((e) => <div key={e.id} id="title">{e.id == tabId ? e.component : ''}</div>)
        )
        }
      </Content.Body>
    </Content>
  );
};
